module.exports = __webpack_public_path__ + "static/media/cryo.9e6a83ff.jpg";